<template>
  <details-sheet :item="device" :headers="headers" v-bind="$attrs">
    <template v-slot:item.date_registration="{ item }">
      {{ item.date_registration | dateFormat }}
    </template>

    <template v-slot:item.states="{ item }">
      {{ item.states.map(({ name }) => name).join(', ') }}
    </template>
  </details-sheet>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';
import DetailsSheet from '@/modules/_global/_components/DetailsSheet.vue';

export default {
  name: 'DeviceDetails',

  filters: {
    dateFormat
  },

  components: {
    DetailsSheet
  },

  props: {
    device: {
      type: Object,
      default: () => ({
        states: []
      })
    }
  },

  computed: {
    headers() {
      return [
        {
          text: `${this.$t('DEVICES.ITEM')} ${this.$t('ITEM.ID')}`,
          value: 'id'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type.name'
        },
        {
          text: this.$t('DEVICES.DEVICE_CODE'),
          value: 'device_code'
        },
        {
          text: this.$t('DEVICES.SERIAL_NUMBER'),
          value: 'serial_number'
        },
        {
          text: this.$t('DEVICES.DATE_OF_REGISTRATION'),
          value: 'date_registration'
        },
        {
          text: this.$t('DEVICES.PHONE'),
          value: 'phone'
        },
        {
          text: this.$t('DEVICES.STATE'),
          value: 'states'
        },
        {
          text: this.$t('ITEM.ADDITIONAL_INFO'),
          value: 'additional_info'
        }
      ];
    }
  }
};
</script>
